{
  "user": {
    "Detayları Düzenle": "Details Bewerken",
    "Foto": "Foto",
    "Hesap": "Account",
    "Mevcut Şifre": "Huidig wachtwoord",
    "Profil": "Profiel",
    "Yeni Resim Yükle": "Nieuwe afbeelding uploaden",
    "Şifre Değiştirme": "Wachtwoord wijziging",
    "Şifre Kontrol": "Wachtwoordcontrole",
    "Bildirim İzinleri": "Meldingstoestemmingen",
    "Bu Cihaz": "Dit Apparaat",
    "Bu cihazdan bildirim alıp almayacağınızı buradan yönetebilirsiniz.": "U kunt hier beheren of u meldingen van dit apparaat wilt ontvangen.",
    "desc_notification_manage": "U kunt hier beheren of u meldingen van dit apparaat wilt ontvangen.",
    "Bildirimleri Kapat": "Meldingen Uitschakelen",
    "Bildirimleri Aç": "Meldingen Inschakelen",
    "Tarayıcınız bildirimleri desteklemiyor": "Uw browser ondersteunt geen meldingen.",
    "Bildirim izni reddedildi Tarayıcı ayarlarından izin verin": "Meldingstoestemming geweigerd. Sta toe via browserinstellingen.",
    "Kayıtlı Cihazlar": "Geregistreerde Apparaten",
    "Cihaz Bilgisi": "Apparaatinformatie",
    "Kayıt Tarihi": "Registratiedatum",
    "Son Erişim": "Laatste Toegang",
    "İşlem": "Actie",
    "Bilinmeyen Cihaz": "Onbekend Apparaat",
    "Kayıtlı cihaz bulunamadı": "Geen geregistreerde apparaten gevonden.",
    "Cihaz listesi alınamadı": "Kan apparaatlijst niet ophalen.",
    "Bu cihazın bildirim aboneliğini silmek istediğinize emin misiniz": "Weet u zeker dat u het abonnement van dit apparaat wilt verwijderen?",
    "Cihaz silindi": "Apparaat verwijderd.",
    "Cihaz silinemedi": "Kan apparaat niet verwijderen."
  }
}
